/**
 * Category show more/less toggle functionality
 * Handles expanding/collapsing category lists in blog archive sidebar
 */

const selectors = {
	toggleButton: '[data-toggle-categories]',
	categoryList: '[data-category-list]',
	textMore: '[data-text-more]',
	textLess: '[data-text-less]',
};

/**
 * Toggles visibility of category items in a group
 *
 * @param {HTMLElement} button - Toggle button that was clicked
 */
const toggleCategories = ( button ) => {

	const groupId = button.dataset.groupId;
	const list = document.querySelector( `[data-category-list][data-group-id="${groupId}"]` );

	if ( !list ) {

		return;

	}

	const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';
	const allItems = list.querySelectorAll( '.c-blog-filters__option' );
	const textMore = button.querySelector( selectors.textMore );
	const textLess = button.querySelector( selectors.textLess );

	if ( isExpanded ) {

		// Collapse - hide items beyond first 6
		allItems.forEach( ( item, index ) => {

			if ( index >= 6 ) {

				item.classList.add( 'is-hidden-initially' );

			}

		} );

		button.setAttribute( 'aria-expanded', 'false' );
		textMore?.classList.remove( 'is-hidden' );
		textLess?.classList.add( 'is-hidden' );

	} else {

		// Expand - show all items
		allItems.forEach( ( item ) => {

			item.classList.remove( 'is-hidden-initially' );

		} );

		button.setAttribute( 'aria-expanded', 'true' );
		textMore?.classList.add( 'is-hidden' );
		textLess?.classList.remove( 'is-hidden' );

	}

};

/**
 * Handles click events on toggle buttons
 *
 * @param {Event} event - Click event
 */
const handleToggleClick = ( event ) => {

	const button = event.target.closest( selectors.toggleButton );

	if ( !button ) {

		return;

	}

	event.preventDefault();
	toggleCategories( button );

};

/**
 * Initializes category toggle functionality
 */
const initCategoryToggle = () => {

	const toggleButtons = document.querySelectorAll( selectors.toggleButton );

	if ( toggleButtons.length === 0 ) {

		return;

	}

	// Use event delegation for better performance
	document.addEventListener( 'click', handleToggleClick );

};

// Initialize on DOM ready
document.addEventListener( 'DOMContentLoaded', initCategoryToggle );

export default initCategoryToggle;
